import * as React from 'react';

const LogoBandsintownColorSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 72 72"
        id="logo-bandsintown-color_svg__eds-icon--logo-bandsintown-color_svg"
        {...props}
    >
        <path
            id="logo-bandsintown-color_svg__eds-icon--logo-bandsintown-color_1"
            fill="#00b4b3"
            d="M0 0h72v72H0z"
        />
        <path
            id="logo-bandsintown-color_svg__eds-icon--logo-bandsintown-color_2"
            fill="#fff"
            d="M63 64V39H23v11h28v2H21V8H9v56h54z"
        />
        <path
            id="logo-bandsintown-color_svg__eds-icon--logo-bandsintown-color_3"
            fill="#fff"
            d="M23 23h12v14H23z"
        />
        <path
            id="logo-bandsintown-color_svg__eds-icon--logo-bandsintown-color_4"
            fill="#fff"
            d="M37 23h12v14H37z"
        />
        <path
            id="logo-bandsintown-color_svg__eds-icon--logo-bandsintown-color_5"
            fill="#fff"
            d="M51 8h12v29H51z"
        />
    </svg>
);

LogoBandsintownColorSvg.displayName = 'LogoBandsintownColorSvg';
export default LogoBandsintownColorSvg;
